/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const GeoBudgetWrap = styled.div`
  min-height: 80px;
  padding: 22px 16px 16px 256px;
  display: grid;
  grid-template-columns: 270px 1fr auto;
  border-top: 1px solid ${Palette.PrimaryGray._200};
`;

export const BidWrap = styled.div`
  height: 76px;

  .MuiInputBase-root {
    background: white;
  }
`;

export const GeoBudgetItemsWrap = styled.ul`
  padding: 0;
  list-style: none;
  grid-column: span 3;
  display: flex;
  column-gap: 10px;
  row-gap: 4px;
  flex-wrap: wrap;
`;

export const GeoBudgetItem = styled.li`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 4px 8px;
  margin-bottom: 6px;
  font-size: 12px;
  color: ${Palette.PrimaryGray._700};
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  user-select: none;
`;

export const IconWrapper = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  border: none;
  background: transparent;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${Palette.PrimaryGray._400};
  }
  :hover {
    background: ${Palette.PrimaryGray._100};
    svg {
      fill: ${Palette.PrimaryGray._500};
    }
  }
  :active {
    background: ${Palette.Primary._000};
    svg {
      fill: ${Palette.Primary._500};
    }
  }
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;
